import { useCallback, useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import ROUTES from '@/common/routes';
import useHistory from '@/modules/core/hooks/useHistory';

const useEditMode = () => {
  const location = useLocation();
  const history = useHistory();
  const { id } = useParams<{ id: string }>();

  const isEditMode = useMemo(() => {
    return location.pathname.endsWith('/edit');
  }, [location.pathname]);

  const activateEditMode = useCallback(() => {
    history.push(ROUTES.PAYOUT_DEFINITION_EDIT_BY_ID(id));
  }, [history, id]);

  const activateViewMode = useCallback(() => {
    history.push(ROUTES.PAYOUT_DEFINITION_VIEW_BY_ID(id));
  }, [history, id]);

  return { isEditMode, activateEditMode, activateViewMode };
};

export default useEditMode;
